import { useEffect, useState } from 'react';

import { useMaxWidthTablet } from 'hooks/useMediaQueries';
import getUsPrivacyString from 'utils/getUsPrivacyString';

const FREESTAR_VAST_BASE = 'https://vid.springserve.com/vast/973422';
const FREESTAR_VAST_SCHAIN = '1.0,1!freestar.com,2085,1';

const MOBILE_VAST_WIDTH = 640;
const MOBILE_VAST_HEIGHT = 480;
const DESKTOP_VAST_WIDTH = 1280;
const DESKTOP_VAST_HEIGHT = 720;

const buildFreestarVastUrl = (usPrivacy: string, width: number, height: number): string => {
  const cb = Date.now();
  const domain = encodeURIComponent(window.location.hostname);
  return `${FREESTAR_VAST_BASE}?w=${width}&h=${height}&cb=${cb}&url=${domain}&us_privacy=${usPrivacy}&schain=${FREESTAR_VAST_SCHAIN}`;
};

const useFreestarAdVastTag = (hasAdFreeCamPermissions: boolean, enabled = true) => {
  const [adVastUrl, setAdVastUrl] = useState('');
  const isMobile = useMaxWidthTablet();

  useEffect(() => {
    if (!enabled || hasAdFreeCamPermissions) {
      setAdVastUrl('');
      return undefined;
    }
    const width = isMobile ? MOBILE_VAST_WIDTH : DESKTOP_VAST_WIDTH;
    const height = isMobile ? MOBILE_VAST_HEIGHT : DESKTOP_VAST_HEIGHT;
    let cancelled = false;
    getUsPrivacyString().then((usPrivacy) => {
      if (cancelled) return;
      setAdVastUrl(buildFreestarVastUrl(usPrivacy, width, height));
    });
    return () => {
      cancelled = true;
    };
  }, [hasAdFreeCamPermissions, enabled, isMobile]);

  return { adVastUrl, adTagLoading: false };
};

export default useFreestarAdVastTag;
